import posthog from "posthog-js";

posthog.init("phc_ikY39bZ895bJW5trBv3uDwSp621q4H6fkQRAevOyQ5a", { api_host: "https://app.posthog.com" });
